module.exports = __webpack_public_path__ + "img/travelling-thali-moodboard.88437122.jpg";